import React from "react"
import Config from "Data"
import styled from "styled-components"
import { theme } from "Theme"
import { BrandedColor, Gap, InlineLink } from "Styles"

const Wrapper = styled.section`
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem 1rem;
  @media (min-width: ${theme.breakpoints.s}) {
    padding: 2rem;
  }

  @media (min-width: ${theme.breakpoints.m}) {
    flex-direction: column;
    margin: 0;
    padding: 2rem;
    width: 100%;
  }

  @media (min-width: ${theme.breakpoints.l}) {
    margin: 0 auto 0;
  }
  max-width: ${theme.layout.base};
`

const Content = styled.div`
  background: #fff;
  border-radius: ${theme.borderRadius.ui};
  border: 1px solid #ddd;
  display: block;
  margin: 0 auto;
  text-align: left;
  width: 100%;
  padding: 2rem;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    padding: 2rem 2rem;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const Grid = styled.div`
  text-align: left;
  margin: 1rem 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(49%, 1fr));
  @media (min-width: ${theme.breakpoints.s}) {
    grid-template-columns: repeat(auto-fill, minmax(49%, 1fr));
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: repeat(auto-fill, minmax(1fr, 1fr));
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  gap: 1rem 12px;
  p {
    margin: 0;
  }
`

const ContactGrid = styled.div`
  text-align: left;
  margin: -3rem 2rem 0;
  display: grid;
  background: ${theme.colors.white.base};
  box-shadow: ${theme.shadow.feature.big.default};
  padding: 2rem;
  grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
  @media (min-width: ${theme.breakpoints.s}) {
    grid-template-columns: repeat(auto-fill, minmax(40%, 1fr));
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: repeat(auto-fill, minmax(1fr, 1fr));
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  gap: 1rem 12px;
  p {
    margin: 0;
  }
`

const Title = styled.h2`
  color: inherit;
  font-weight: bold;
  max-width: ${theme.layout.base};
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 2rem;
`

const Faq = ({ title }) => (
  <>
    <Wrapper>
      <Content>
        <Title>
          <BrandedColor>{title}</BrandedColor>
        </Title>
        <Grid>
          <div>
            <h4>How can I get to the venue?</h4>
            <p>FREE Uber passes are on us or take Valet at NO cost.</p>
          </div>
          <div>
            <h4>Is there a FEE?</h4>
            <p>Being a closed-door event of 100 leaders that were specifically invited there is NO fee to attend.</p>
          </div>
          <div>
            <h4>Are there any speaking opportunities?</h4>
            <p>
              If you would like to be considered for seat on one of the panels CLICK HERE to let us know and we'll be in
              touch.
            </p>
          </div>
          <div>
            <h4>Can I refer a colleague?</h4>
            <p>
              All referrals must be approved by our event producer. Simply CLICK HERE to submit your referral for
              approval.
            </p>
          </div>
        </Grid>
        <Gap />
      </Content>
      <ContactGrid>
        <div>
          <h3>Questions?</h3>
          <p>
            For any questions, please contact{" "}
            <InlineLink
              to="mailto:rupenp@cxosync.com"
              track={"FAQ Questions?"}
              title={"Send Email"}
              style={{
                fontWeight: "bold",
                textDecoration: "underline",
                color: `${theme.colors.primary.base}`,
              }}>
              rupenp@cxosync.com
            </InlineLink>{" "}
            or call{" "}
            <InlineLink
              to={`tel:${Config.contact.phone.us}`}
              track={"FAQ Questions?"}
              title={"Call Number"}
              style={{
                fontWeight: "bold",
                textDecoration: "underline",
                color: `${theme.colors.primary.base}`,
              }}>
              {Config.contact.phone.us}
            </InlineLink>
          </p>
        </div>
        <div>
          <h3>Sponsor</h3>
          <p>
            To sponsor or exhibit at an upcoming event, contact{" "}
            <InlineLink
              to="mailto:rupenp@cxosync.com"
              track={"FAQ Sponsor?"}
              title={"Send Email"}
              style={{
                fontWeight: "bold",
                textDecoration: "underline",
                color: `${theme.colors.primary.base}`,
              }}>
              rupenp@cxosync.com
            </InlineLink>{" "}
            or call{" "}
            <InlineLink
              to={`tel:${Config.contact.phone.us}`}
              track={"FAQ Sponsor?"}
              title={"Call Number"}
              style={{
                fontWeight: "bold",
                textDecoration: "underline",
                color: `${theme.colors.primary.base}`,
              }}>
              {Config.contact.phone.us}
            </InlineLink>
          </p>
        </div>
      </ContactGrid>
    </Wrapper>
  </>
)

export default Faq
